module.exports = __webpack_public_path__ + "static/img/3d_top3.100ef07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/3d_top3.png
// module id = dTo8
// module chunks = 1